<template>
  <div class="page-container">
    <div class="page-header" v-if="state.moduleType == ModuleType.College">
         <van-tabs v-model:active="active" type="card" @click-tab="handleClickTab">
            <van-tab :name="1" title="签约中"></van-tab>
            <van-tab :name="0" title="未签约"></van-tab>
        </van-tabs>
    </div>
    <div class="page-header" v-if="state.moduleType == ModuleType.Active">
         <van-tabs v-model:active="active" type="card" @click-tab="handleClickTab">
            <van-tab :name="1" title="生效中"></van-tab>
        </van-tabs>
    </div>
    <div class="page-header" v-if="state.moduleType == ModuleType.Pending">
         <van-tabs v-model:active="active" type="card" @click-tab="handleClickTab">
            <van-tab :name="0" title="待生效"></van-tab>
        </van-tabs>
    </div>
    <div class="page-content">
      <van-search style="margin-top: 4px;" @search="onSearch" show-action background="#e9f1f8" shape="round" v-model="state.searchValue" placeholder="请输入姓名搜索">
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>

      <div class="content">
        <van-pull-refresh v-model="state.refreshing" @refresh="onRefresh">
          <van-list
            v-model:loading="state.loading"
            :finished="state.finished"
            finished-text="没有更多了"
            @load="onLoad"
            :offset="100"
            :immediate-check="false"
          >
            <div v-if="!state.list.length && !state.loading" class="empty-wrap">
              <EmptyData />
            </div>
            <div class="content-item" v-for="item in state.list" :key="item.id" @click="handleGoDetail(item)">
                <div class="item-header">
                    <van-image width="80" height="80" :src="getImg(item.faceImg)" fit="contain" @click.stop="previewImage(getImg(item.faceImg))" style="cursor: pointer">
                        <template v-slot:loading>
                            <van-loading type="spinner" size="20" />
                        </template>
                        <template v-slot:error>
                            <van-image width="80" height="80" :src="DefaultAvatar" @click.stop="previewImage(DefaultAvatar)" style="cursor: pointer"/>
                        </template>
                    </van-image>
                    <div style="margin-left: 12px;flex: 1;">
                        <div class="item-header-info">
                            <div class="item-header-info-name">{{item.realName}} <span>{{SexText[item.sex]}}</span></div>
                            <div class="item-header-info-status" v-if="active == 1">{{HospitalStatusText[item.status]}}</div>
                        </div>
                        <div class="item-header-info" v-if="item.belongTeacherName">
                            <span class="item-header-info-other" style="color: #1989fa;font-size: 14px;font-weight: 500;">
                              导师：{{ item.belongTeacherName }}
                            </span>
                        </div>
                        <div class="item-header-info" v-if="active == 1">
                            <span class="item-header-info-other" style="color: #113050;font-size: 14px;font-weight: 500;">{{item.businessName}}</span>
                            <span class="item-header-info-other">{{ getDay(item.checkInDate,'YYYY-MM-DD') }}~{{ getDay(item.expireDate,'YYYY-MM-DD') }}</span>
                        </div>
                        <div v-if="active == 1" class="item-header-info"><span class="item-header-info-other">已签到{{item.record ?? '--'}}天，剩余<p>{{item.leftOver ?? '--'}}</p>天</span></div>
                    </div>
                </div>
                <div v-if="active == 1" class="item-des"><span></span> 最新回院：{{item.admissionTime ?? '--'}}</div>
                <div v-if="active == 1" class="item-des"><span  style="background:#5470C6"></span> 最新出院：{{item.exitTime ?? '--'}}</div>
                <div v-if="active == 1" class="item-des"><span  style="background:#383838"></span> 最新签到时间：{{getDay(item.recentPerformanceTime) ?? '--'}}</div>

            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, onMounted, reactive, ref } from 'vue';
  import { useRoute, useRouter } from "vue-router";
  import { ModuleType, SexText, HospitalStatusText } from '@/utils/const' 
  import { queryGetSignStu } from "@/api/user";
  import EmptyData from '@/components/EmptyData.vue';
  import DefaultAvatar from '@/assets/avatar.jpg';
  import { getImg } from '@/utils/methods';
  import dayjs from "dayjs";
  import { showImagePreview } from 'vant';

  export default defineComponent({
    name: 'CollegeStudents',
    
    components: {
        EmptyData
    },

    setup() {
     const route = useRoute();

     const router = useRouter();

     const active = ref(1)

     const state = reactive({
        list: [],
        moduleType : route?.query?.moduleType,
        searchValue: null,
        loading: false,
        refreshing: false,
        finished: false,
        pageIndex: 1,
        pageSize: 10
     })

      onMounted(() => {
        console.log("页面初始化，开始加载数据");
        queryGetSignStuData();
      });

    const queryGetSignStuData = async (reset = false) => {
      if (reset) {
        state.pageIndex = 1;
        state.finished = false;
        state.list = [];
      }

      try {
        const params = {
            signStatus: active.value,
            oneSelf: route?.query?.oneSelf,
            permissionOrg: route?.query?.permissionOrg,
            realName: state.searchValue
        }

        if(state.moduleType == ModuleType.College) {
            delete params.expireDate
        } else if(state.moduleType == ModuleType.Due) {
            // TODO  即将到期
            params.expireDate = dayjs().format('YYYY-MM-DD')
        } else if(state.moduleType == ModuleType.InCourtyard) {
           params.checkInStatus = 2
        } else if(state.moduleType == ModuleType.Active) {
           // 生效中状态
           params.activeStatus = 1
        } else if(state.moduleType == ModuleType.Pending) {
           // 待生效状态
           params.activeStatus = 0
        }

        state.loading = true;
        const result = await queryGetSignStu({
            page:{
                pageIndex: state.pageIndex,
                pageSize: state.pageSize
            },
            ...params
        });
        console.log("result:", result);

        state.loading = false;
        if (result.code === "00") {
          const list = result.data?.list ?? [];
          state.list = [...state.list, ...list];

          console.log("加载数据:", {
            currentPage: state.pageIndex,
            loadedCount: list.length,
            totalListCount: state.list.length,
            totalFromServer: Number(result.data?.total),
            pages: result.data?.pages
          });

          // 检查是否还有更多数据
          if (result.data?.pages && state.pageIndex >= result.data.size) {
            // 服务器明确告诉我们这是最后一页
            state.finished = true;
            console.log("数据加载完成：服务器返回最后一页");
          } else if (result.data?.total && state.list.length >= Number(result.data?.total)) {
            // 已加载完所有数据
            state.finished = true;
            console.log("数据加载完成：已加载所有数据");
          } else if (list.length === 0) {
            // 当前页没有数据，说明没有更多数据了
            state.finished = true;
            console.log("数据加载完成：当前页无数据");
          } else if (list.length < state.pageSize) {
            // 当前页数据不足，说明这是最后一页了
            state.finished = true;
            console.log("数据加载完成：当前页数据不足，说明没有更多数据");
          } else {
            // 数据足够，继续加载下一页
            state.pageIndex += 1;
            console.log("继续加载下一页");
          }
        } else {
          state.finished = true;
          console.log("API返回错误，停止加载");
        }
      } catch (error) {
        console.log("error:>>>", error);
        state.loading = false;
        state.finished = true;
      } finally {
        state.refreshing = false;
      }
    }

      const handleGoDetail = (row) => {
        router.push({
            path: '/studentsInfo',
            query: {
                userId: row.id
            }
        })
      }

      const handleClickTab = () => {
        queryGetSignStuData(true);
      };

      const getDay = (day,format='YYYY-MM-DD HH:mm:ss') => {
        return day ? dayjs(day).format(format) : '--'
      }

      const onSearch = () => {
        queryGetSignStuData(true)
      }

      const onRefresh = async () => {
        await queryGetSignStuData(true);
      }

      const onLoad = async () => {
        console.log("onLoad triggered:", {
          loading: state.loading,
          finished: state.finished,
          pageIndex: state.pageIndex
        });
        if (!state.finished) {
          await queryGetSignStuData();
        } else {
          console.log("onLoad skipped: finished =", state.finished);
        }
      }

      const previewImage = (imageUrl) => {
      console.log("imageUrl>>>>", imageUrl);
      if (!imageUrl) return;
      showImagePreview({
        images: [imageUrl],
        showIndex: false,
        closeable: true,
        closeOnPopstate: true,
      });
    };

      return {
        active,
        state,
        ModuleType,
        handleGoDetail,
        DefaultAvatar,
        getImg,
        handleClickTab,
        SexText,
        HospitalStatusText,
        getDay,
        onSearch,
        onRefresh,
        onLoad,
        previewImage
      };
    },
  });
</script>

<style lang="scss" scoped>
.page-container {
  background: #e9f1f8;
  min-height: 100vh;
  width: 100%;
}

.page-content {
  padding: 0 10px;
}

.content {
  padding: 10px 0;
}

.empty-wrap {
  margin-top: 40px;
}

.page-header {
    padding: 12px;
    margin: 0 68px;
}

.content-item {
    background: #fff;
    margin: 12px 8px;
    border-radius: 4px;
    padding: 12px;
    text-align: left;

    .item-header {
        display: flex;

        .item-header-info {
            display: flex;
            justify-content: space-between;

            .item-header-info-name {
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 18px;
                color: #000000;
                font-weight: 600;

                span {
                    font-size: 16px;
                    font-weight: 500;
                    color: burlywood;
                }
            }

            .item-header-info-status {
                color: #fff;
                font-size: 14px;
                background: #113050;
                padding: 4px 12px;
                border-radius: 24px;
            }

            .item-header-info-other {
                font-family: PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #666666;
                display: flex;
                align-items: center;
                height: 22px;

                p {
                    color: #FF3638;
                }
            }

        }
    }

    .item-des {
        display: flex;
        align-items: center;
        margin-top: 10px;
        font-size: 14px;

        span {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #EE6666;
            margin-right: 4px;
            display: inline-block;
        }
    }
}
</style>